<div class="options-container">
  <button *ngFor="let option of options" type="button" [class.selected]="selectedOptions.includes(option)" [class.error]="submitted && selectedOptions.length === 0" (click)="handleSelect(option)">
    <span>{{option}}</span>
    <i *ngIf="selectedOptions.includes(option)" class="fas fa-circle-check"></i>
  </button>
  <span *ngIf="submitted && selectedOptions.length === 0" class="error">Bitte wähle eine Option aus</span>
</div>